import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgLikeOutline = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-like-outline';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M11.002 3.33c-.019.05-.81 1.845-1.757 3.99l-1.722 3.9-2.142.01-2.141.011v9.519h7.062c7.948 0 7.383.022 8.058-.308.327-.159.434-.239.762-.568.326-.327.41-.44.569-.764.102-.209.222-.515.267-.68.111-.415.817-7.862.781-8.24q-.148-1.517-1.468-1.867c-.214-.056-.567-.068-2.378-.082l-2.127-.017-.016-1.367c-.017-1.514-.021-1.541-.301-2.087-.102-.197-.247-.383-.491-.626-.29-.29-.407-.376-.722-.528-.207-.1-.49-.21-.629-.246-.274-.069-.913-.136-1.318-.139-.224-.001-.255.009-.287.089m1.518 1.615c.256.115.49.328.613.555.086.157.087.195.098 2.21l.012 2.05 2.788.002c2.051.002 2.826.015 2.929.05.176.06.28.255.28.526 0 .207-.661 7.34-.703 7.58-.08.465-.427.964-.822 1.183l-.215.119-4.37.011-4.37.01v-7.103l1.563-3.539c.859-1.946 1.588-3.6 1.619-3.673.055-.128.066-.134.208-.108.082.015.249.072.37.127M7.24 16v3.24H4.76v-6.48h2.48z"
    })
  }));
});
export default SvgLikeOutline;